import MainCard from './MainCard';

export default MainCard;
